import React from "react";
import { useTranslation } from "react-i18next";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";

import { FidelityFormApi } from "../useFidelityForm";

type Props = {
    form: FidelityFormApi;
    setIsEdited: (v: boolean) => void;
    isConsultModalOpened: boolean;
};

export function RemarkField({ form, setIsEdited, isConsultModalOpened }: Props) {
    const { t } = useTranslation();
    const { values, flags, setValue } = form;

    const readOnlyClass = classnames("", {
        "not-allowed-icon__clz":
            flags.isCentralizationActive && isConsultModalOpened,
    });

    return (
        <AvGroup>
            <StyledLabel className="mt-3" htmlFor="name">
                {t("Remark")}
            </StyledLabel>
            <StyledTextInput
                data-testid="fidelity-information-remark-input"
                autocomplete="off"
                id="remark"
                name="remark"
                placeholder={t("Write")}
                type="text"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setValue("remark", e.target.value);
                    setIsEdited(true);
                }}
                className={readOnlyClass}
                value={values.remark}
            />
        </AvGroup>
    );
}
